import React from "react";
import { useSelector } from "react-redux";

export function getTranslation(translationCode: string) {
  const translationsState = useSelector((state: any) => state.translationsReducer);
  const currentLanguage = translationsState.currentLanguage;
  const translations = translationsState.translations;

  return translations[translationCode] && translations[translationCode][currentLanguage] ?
    translations[translationCode][currentLanguage]
    : null;
}
